import Button from "@/components/Button";
import Image from "next/image";
import Link from "next/link";
import posthog from "posthog-js";

const TopSection = () => {
    return (
        <div className="bg-linear-to-b from-[#99B4BF] to-[#99B4BF] dark:from-[#1a5b77] dark:to-[#1a5b77] rounded-2xl mb-8">
            <div
                className="relative w-full mx-auto bg-linear-to-b from-[#DEE9ED] to-[#99B4BF] dark:from-[#2a6b87] dark:to-[#1a5b77] rounded-2xl"
                style={{
                    backgroundImage: `radial-gradient(circle, #FFFFFF33 20%, transparent 60%, #5A7E8C00 100%)`,
                }}
            >
                <div className="flex flex-col lg:flex-row items-end justify-between">
                    <div className="text-white flex flex-col justify-center w-full lg:w-2/3 p-3 lg:py-12 lg:pl-12 2xl:p-12">
                        <div className="text-white text-[36px] lg:text-[56px] font-semibold font-satoshi uppercase leading-[37.40px] lg:leading-[61.60px]">
                            Complex illness treatment without the wait
                        </div>
                        <div className="lg:w-2/3 text-white text-base lg:text-[22px] font-normal lg:font-light font-space leading-snug md:leading-[30.80px] mt-4">
                            RTHM provides prescriptions for hard to find
                            medications for Long COVID, ME/CFS, POTS and MCAS.
                        </div>
                        <div className="flex flex-col lg:flex-row gap-4 mt-6">
                            <Link
                                href="/treatments"
                                className="w-full"
                                onClick={() => {
                                    posthog?.capture(
                                        "find_treatment_button_clicked",
                                    );
                                }}
                            >
                                <Button
                                    id="find-treatment"
                                    text="Find a specific treatment"
                                    type="filled"
                                    className="border-[#1a5b77] w-full py-4 uppercase"
                                    height="h-[72px]"
                                />
                            </Link>
                            <Link
                                href="/discover"
                                className="w-full"
                                onClick={() => {
                                    posthog?.capture(
                                        "help_me_choose_button_clicked",
                                    );
                                }}
                            >
                                <Button
                                    id="help-me-choose"
                                    text="Help me choose a treatment"
                                    type="outlined"
                                    className="bg-white dark:!text-[#1a5b77] w-full py-4 uppercase"
                                    height="h-[72px]"
                                />
                            </Link>
                        </div>
                    </div>

                    <div className="w-full lg:w-1/2">
                        <Image
                            src="/images/marketing/Homepage.png"
                            alt="Complex illness treatment"
                            className="rounded-2xl"
                            loading="eager"
                            priority
                            width={1400}
                            height={760}
                            style={{
                                width: "100%",
                                height: "auto",
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopSection;
